import { configureStore } from '@reduxjs/toolkit';
import partnerReducer from '../features/partner/partnerSlice';
import authReducer from '../features/auth/authSlice';

export const store = configureStore({
  reducer: {
    partner: partnerReducer,
    auth: authReducer,
  },
})
